import Tooltip from 'jl-design-system/components/tooltip/Tooltip';
import { InfoOutlined } from 'jl-design-system/components/icons/InfoOutlined';

export const RoomOrSpaceTooltip = (props) => {
  const { usedFor } = props;

  return (
    <Tooltip id="only-icon" anchor="center" buttonLabel={<InfoOutlined size="medium" />}>
      {usedFor === 'floor' ? (
        <p>
          When adding stairs, make sure you add your hallway and landing by &#39;Add another
          product&#39; if it is required
        </p>
      ) : (
        <p>Remember to add tracks and poles if also required by selecting add another product</p>
      )}
    </Tooltip>
  );
};
